module.exports = __webpack_public_path__ + "img/partners_bordered.106d2f04.png";